/**
 * 二手车列表
 * http://mockjs.com/
url： https://testzsqy.cheanjia.com/?mock=1#/sms/4
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取上次提交合同信息+get
// 接口地址 /api/v1/used_car/ticket/<int:ticket_id>/contract
Mock.mock(/used_car\/ticket\/\d+\/contract/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'id': 1, // # 合同编号
    'price': 10000, // # 合同价格
    'recepit_name': '收款人姓名',
    'bank_name': '开户行',
    'bank_card_number': '6222024000083840516',
    'note': 'gegerge个个人个人个人个人个人好人人',
    'images': [{
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '合同',
      'code': 'contract'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '车辆正面45度',
      'code': 'vehicle_front_45_degree'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '车钥匙',
      'code': 'vehicle_key'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '行驶证',
      'code': 'vehicle_license'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '登记证',
      'code': 'vehicle_registration'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '身份证正面',
      'code': 'personal_identification_front'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '身份证反面',
      'code': 'personal_identification_back'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '购车发票',
      'code': 'vehicle_receipt'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '保养手册',
      'code': 'vehicle_maintenance_manual'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '交强险',
      'code': 'vehicle_mandatory_insurance'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '商业险',
      'code': 'vehicle_commercial_insurance'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '购置税',
      'code': 'vehicle_purchase_tax'
    }, {
      'src': 'http://img1.imgtn.bdimg.com/it/u=4075700132,2708783571&fm=21&gp=0.jpg', // # 图片地址
      'name': '银行卡正面',
      'code': 'bank_card_front'
    }]
  }
})

// 提交记录+put
// 接口地址 /api/v1/used_car/ticket/<int:ticket_id>/contact
Mock.mock(/used_car\/ticket\/\d+\/contact/, 'put' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {}
})

// 提交估价+put
// 接口地址  /api/v1/used_car/ticket/<int:ticket_id>/appraise
Mock.mock(/used_car\/ticket\/\d+\/appraise/, 'put' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {}
})

// 提交估价+put
// 接口地址  /api/v1/used_car/ticket/<int:ticket_id>/contract
Mock.mock(/used_car\/ticket\/\d+\/contract/, 'put' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {}
})

// 提交估价+put
// 接口地址  /api/v1/used_car/ticket/<int:ticket_id>/finish
Mock.mock(/used_car\/ticket\/\d+\/finish/, 'put' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {}
})
// 上传照片+put
// 接口地址  /save-wx-image/{media_id}
Mock.mock(/save-wx-image/, 'put' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'url：': 'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1486298542971&di=70484f4dd636ab231331dd8e2a4be705&imgtype=0&src=http%3A%2F%2Fwww.leewiart.com%2Fuserfiles%2F24160%2F2592c71b5cdd404481d0634288dd7d90.jpg'
  }
})
